import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN ?? "",
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? "local",
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACESSAMPLERATE) ?? 0.2,
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYSSESSIONSAMPLERATE) ?? 0.2,
    replaysOnErrorSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAYSONERRORSAMPLERATE) ?? 1.0,
});
